import { render, staticRenderFns } from "./author-user-create.html?vue&type=template&id=7d6795d8&scoped=true&"
import script from "./author-user-create.js?vue&type=script&lang=js&"
export * from "./author-user-create.js?vue&type=script&lang=js&"
import style0 from "./author-user-create.scss?vue&type=style&index=0&id=7d6795d8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d6795d8",
  null
  
)

export default component.exports